<div class="content__inner">
    <header class="content__title">
        <h1>{{ "tours.list.title" | translate }}</h1>
        <small>{{ "tours.list.subtitle" | translate }}</small>

        <div class="actions">
            <button *appHasPermission="'TOURS.ADD'" (click)="addTour()" class="btn btn-success btn--icon-text" style="margin-left: 25px"><i class="zmdi zmdi-collection-plus"></i> {{ "tours.list.add" | translate }}</button>
        </div>
    </header>

    <div class="card" *appHasPermission="'TOURS.LIST'">
        <div class="card-body">
            <h4 class="card-title">{{ "tours.list.card.title" | translate }}</h4>

            <mat-form-field class="search-field">
                <mat-label>{{ "global.datatable.search" | translate }}</mat-label>
                <input matInput [formControl]="pageState.searchInputControl" [autocomplete]="'off'" />
            </mat-form-field>

            <!-- Table -->
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)" [matSortActive]="pageState.sortState.active" [matSortDirection]="pageState.sortState.direction">
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "tours.props.name" | translate }}</th>
                        <td mat-cell *matCellDef="let row" [attr.role]="hasToursEditPermission ? 'button' : undefined" (click)="hasToursEditPermission && editTour(row._id)">{{ row.name }}</td>
                    </ng-container>

                    <ng-container matColumnDef="fromDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "tours.props.fromdate" | translate }}</th>
                        <td mat-cell *matCellDef="let row" [attr.role]="hasToursEditPermission ? 'button' : undefined" (click)="hasToursEditPermission && editTour(row._id)">{{ row.fromDate | date: "yyyy-MM-dd" }}</td>
                    </ng-container>

                    <ng-container matColumnDef="toDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "tours.props.todate" | translate }}</th>
                        <td mat-cell *matCellDef="let row" [attr.role]="hasToursEditPermission ? 'button' : undefined" (click)="hasToursEditPermission && editTour(row._id)">{{ row.toDate | date: "yyyy-MM-dd" }}</td>
                    </ng-container>

                    <ng-container matColumnDef="visited">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "tours.props.visited" | translate }}</th>
                        <td mat-cell *matCellDef="let row" [attr.role]="hasToursEditPermission ? 'button' : undefined" (click)="hasToursEditPermission && editTour(row._id)">
                            {{ row.visitedDistributorCount }} / {{ row.totalDistributorCount }} ( {{ row.totalDistributorCount !== 0 ? (row.visitedDistributorCount / row.totalDistributorCount | percent: "1.0") : "0%" }} )
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="createdByMail">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "tours.props.createdByMail" | translate }}</th>
                        <td mat-cell *matCellDef="let row" [attr.role]="hasToursEditPermission ? 'button' : undefined" (click)="hasToursEditPermission && editTour(row._id)">
                            {{ row.createdByMail }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let row">
                            <div class="d-flex justify-content-end">
                                <span class="flex-grow-1 position-relative" *appHasPermission="'TOURS.EDIT'">
                                    <span role="button" (click)="editTour(row._id)" class="position-absolute tour-action-padding"> </span>
                                </span>
                                <i (click)="editTour(row._id)" class="zmdi zmdi-edit zmdi-hc-fw tableIcon" *appHasPermission="'TOURS.EDIT'"></i>
                                <i (click)="duplicateTour(row._id, row.name)" class="zmdi zmdi-copy zmdi-hc-fw tableIcon" *appHasPermission="'TOURS.EDIT'"></i>
                                <i (click)="deleteTour(row._id)" class="zmdi zmdi-delete zmdi-hc-fw tableIcon" *appHasPermission="'TOURS.DELETE'"></i>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
            </div>

            <mat-paginator
                class="flex inset-x-0 bottom-0 border-t border-b-0 z-10 bg-gray-50 dark:bg-transparent"
                #paginator
                [length]="pageState.totalRows"
                [pageIndex]="pageState.currentPage"
                [pageSize]="pageState.pageSize"
                [pageSizeOptions]="pageState.pageSizeOptions"
                showFirstLastButtons
                (page)="pageChanged($event)"
            >
            </mat-paginator>
        </div>
    </div>
</div>
